// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import venueCards from './js/widgets/venueCards.js';
import seoWidget from './js/widgets/seoWidget.js';
import seoCardsWidget from './js/widgets/seoCardsWidget.js';
import multiSchedule from './js/widgets/multiSchedule.js';
import sponsors from './js/widgets/sponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    swiperWidget();
    venueCards();
    seoWidget();
    seoCardsWidget();
    multiSchedule();
    sponsors();
  });
}

$(document).ready(function () {
  headerButton();
});
